import {DisputeDecisionReasonTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class DisputeDecisionReasonTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in DisputeDecisionReasonTypeCd ) {
      this._values.push(DisputeDecisionReasonTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): DisputeDecisionReasonTypeCd {

    for ( const obj in DisputeDecisionReasonTypeCd ) {
      if (DisputeDecisionReasonTypeCd[obj] === value){
        return DisputeDecisionReasonTypeCd[obj] as DisputeDecisionReasonTypeCd;
      }
    }
  }
}

const DisputeDecisionReasonTypeCdHelper = new DisputeDecisionReasonTypeCdHelperEnumHelperClass();
export default DisputeDecisionReasonTypeCdHelper;
